// True while scripts/prerender.js renders the page in headless Chrome at build time.
export const isPrerender = typeof navigator !== 'undefined' && navigator.userAgent.includes('MimacPrerender')

// Data baked in at build time by scripts/prerender.js (see public/.htaccess), so the first
// client render already shows the same content as the prerendered HTML.
export const preloaded = (typeof window !== 'undefined' && window.__PRELOADED__) || {}
